import { render, staticRenderFns } from "./bodegas-etchart.vue?vue&type=template&id=9f311acc&scoped=true"
import script from "./bodegas-etchart.vue?vue&type=script&lang=js"
export * from "./bodegas-etchart.vue?vue&type=script&lang=js"
import style0 from "./bodegas-etchart.vue?vue&type=style&index=0&id=9f311acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f311acc",
  null
  
)

export default component.exports